/* eslint-disable */
// このファイルは自動生成されています。直接編集しないでください。
// 生成元: src/data/_generateCustomJson.js

/**
 * ミッション全数
 * @type {number}
 */
export const TOTAL_MISSIONS = 19 as const;

/**
 * スペシャルエリアのミッションID
 * @type {ReadonlyArray<string>}
 */
export const SPECIAL_AREA_MISSION_IDS = ['11', '12', '13', '14', '15', '16', '17', '18', '19'] as const;

/**
 * スペシャルエリアのミッションIDの型
 */
export type SpecialAreaMissionId = (typeof SPECIAL_AREA_MISSION_IDS)[number];

// ファイルをモジュールとして認識させるための空のexport
export {};
